<template>
  <div>
    <div class="info_box">
      <div class='vxreset'>
        <div class="server-row">
          <div class="select-wrapper">
            <select :class="{placeholder: logicalRegionId===''}" v-model="logicalRegionId" disabled>
              <option value="" disabled hidden>请选择大区</option>
              <option :value="1010">官方区</option>
            </select>
            <i class="drop_down"></i>
          </div>
          <div class="select-wrapper">
            <select :class="{placeholder: serverId===''}" v-model="serverId">
              <option value="" disabled hidden>请选择区服</option>
              <option v-for="option in serverOptions" :key="option[0]" :value="option[0]">{{option[1]}}</option>
            </select>
            <i class="drop_down"></i>
          </div>
        </div>
      </div>
      <div class='vxreset'>
        <i class="account_icon"></i>
        <input type='text' placeholder='请输入角色编号' :class="'log-input' + (showId==''?' log-input-empty':'')" name='showId' v-model='showId'>
      </div>
      <div class='vxreset verification last'>
        <div style="margin-bottom: 0;width:256px;">
          <i class="pwd_icon"></i>
          <input type='text' placeholder='短信验证码' class="code" v-model='verificationCode'>
        </div>
        <span class="get_code" v-if='getting === false' @click="getVerCode()">获取验证码</span>
        <span class="get_code" v-if='getting'>{{ get_time }}s</span>
      </div>
      <div class="info_tip">
        <span v-if="tipInfo !==''"></span>
        <p>{{tipInfo}}</p>
      </div>

      <div class="help-tip">注：角色验证后，将登录角色所属的游戏账号！</div>

    </div>

    <div class='btn_box'>
      <span class='confirm' @click="login()">登 录</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'VerificationCodeLoginForm',
  data () {
    return {
      tipInfo: '',
      logicalRegionId: 1010,
      serverId: '',
      showId: '',
      verificationCode: '',
      getting: false,
      get_time: 60,
      isLoading: false
    }
  },
  mounted () {
    this.$store.dispatch('fetchServersByLogicalRegionId', this.logicalRegionId)
  },
  computed: {
    ...mapGetters(['appAndServer']),
    serverOptions () {
      const target = this.appAndServer.find(item => item.value === this.logicalRegionId)
      if (target) {
        return target.servers || []
      }
      return []
    }
  },
  methods: {
    check (keys) {
      if (!keys) keys = ['logicalRegionId', 'serverId', 'showId', 'verificationCode']
      return keys.every(key => this._checkItem(key))
    },
    _checkItem (key) {
      this.tipInfo = ''
      switch (key) {
        case 'logicalRegionId':
          if (this.logicalRegionId === '' || this.logicalRegionId === undefined) {
            this.tipInfo = '请选择大区'
            return false
          }
          return true
        case 'serverId':
          if (this.serverId === '' || this.serverId === undefined) {
            this.tipInfo = '请选择区服'
            return false
          }
          return true
        case 'showId':
          if (this.showId === '' || this.serverId === undefined) {
            this.tipInfo = '请输入角色编号'
            return false
          }
          if (!/^\d+$/.test(this.showId)) {
            this.tipInfo = '角色编号由纯数字组成'
            return false
          }
          return true
        case 'verificationCode':
          if (this.verificationCode === '' || this.verificationCode === undefined) {
            this.tipInfo = '请输入验证码'
            return false
          }
          if (!/^\d{6}$/.test(this.verificationCode)) {
            this.tipInfo = '验证码为6位数字'
            return false
          }
          return true
        default:
          return false
      }
    },
    getVerCode () {
      if (!this.check(['logicalRegionId', 'serverId', 'showId'])) return

      this.get_time = 60
      if (this.showId !== '') {
        const formData = {
          logical_region_id: this.logicalRegionId,
          server_id: this.serverId,
          show_id: parseInt(this.showId)
        }
        this.axios.post('/api/interface/account/send_wsy_code_email', formData).then(res => {
          if (res.data.state === 0) {
            this.getting = true
            this.$toast('验证码已发送，可到游戏内邮箱查看！')
            var timer = setInterval(() => {
              this.get_time--
              if (this.get_time <= 0) {
                this.getting = false
                clearInterval(timer)
              }
            }, 1000)
          } else {
            this.tipInfo = res.data.msg
          }
        }).catch(() => {
          this.tipInfo = '网络错误，请重试！'
        })
      }
    },
    login () {
      if (this.isLoading) return
      if (!this.check()) return
      this.toLogin()
    },
    toLogin () {
      // let passwordMd5 = md5(this.password)
      if (!this.isLoading) {
        this.isLoading = true
        this.$emit('loading', true)
        this.formData = {
          login_type: 'role',
          logical_region_id: this.logicalRegionId,
          server_id: this.serverId,
          show_id: parseInt(this.showId),
          verification_code: this.verificationCode
        }
        this.axios.post('/api/interface/login', this.formData).then(res => {
          if (res) {
            this.$emit('loading', false)
            if (res.data.state === 0) {
              const account = res.data.uid || '账号不存在'
              this.$store.commit('SET_BASEINFO', {
                account: account,
                password: '',
                token: res.data.token,
                id: res.data.uid,
                is_first: res.data.is_first,
                is_bind: res.data.is_bind,
                is_login_by_show_id: true
              })
              this.setCookie(res.data.token, 30)
              setTimeout(() => {
                window.location.reload()
              })
            } else {
              this.password = ''
              this.tipInfo = res.data.msg
            }
            this.isLoading = false
          }
        })
      }
    },
    // 设置cookie
    setCookie (token, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'Access-Token' + '=' + token + ';path=/;expires=' + exdate.toGMTString()
    }
  }
}
</script>
<style lang="less" scoped  rel="stylesheet/less">
.vip_icon{
  margin: 20px auto;
  text-align: center;
  img{
    width: 182px;
    height: 59px;
  }
}
.info_box{
  padding: 0 25px;
  .last{
    padding-bottom: 0!important;
  }
  .vxreset {
    padding-bottom: 19px;
    text-align: center;
    clear: both;
    height: 48px;
    position: relative;
    i{
      display: block;
      width: 18px;
      position: absolute;
      left: 11px;
    }
    .account_icon{
      top:12px;
      height: 18px;
      background: url("../../../static/img/common/account_icon.png")no-repeat;
    }
    .pwd_icon{
      top:10px;
      height: 22px;
      background: url("../../../static/img/common/pwd_icon.png")no-repeat;
    }
    .server-row {
      display: flex;
      justify-content: space-between;
      // .select-wrapper:first-child select {
      //   border-right: 0;
      // }
    }
    .select-wrapper {
      position: relative;
      width: 100%;
      select {
        width: 192px;
        background-color: #fff;
        border: 1px solid #c5c5c5;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #1f2d3d;
        height: 48px;
        padding: 3px 40px 3px 16px;
        // text-align: center;
        -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        // width: 100%;
        font-size: 16px;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        overflow: hidden;
        border-radius: 5px;
        &.placeholder {
          color: rgb(106, 106, 106);
        }
      }
      i.drop_down{
        position: absolute;
        width: 0;
        height: 0;
        top: 17px;
        right: 11px;
        left: auto;
        bottom: auto;
        border:8px solid #b3b3b3;
        border-width: 8px 8px 8px;
        border-color: #5a5a5a transparent transparent transparent;
        z-index: 2;
        pointer-events:none;
        background: none;
      }
    }
    &.verification {
      display: flex;
      justify-content: space-between;
    }
    .get_code{
      cursor: pointer;
      display: block;
      width: 129px;
      height: 48px;
      line-height: 48px;
      float: left;
      font-size: 16px;
      color: #fff;
      letter-spacing: 1px;
      background: url("../../../static/img/common/code_btn.png")no-repeat;
      background-size: contain;
    }
    input {
      background-color: #fff;
      border: 1px solid #c5c5c5;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #1f2d3d;
      height: 48px;
      padding: 3px 10px 3px 40px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      float: left;
      width: 100%;
      font-size: 16px;
      border-radius: 5px;
      &:focus {
        border-color: #d1434a;
      }
    }
  }
  .info_tip{
    position: relative;
    padding: 10px 10px 10px 20px;
    height: 13px;
    span{
      display: block;
      width: 14px;
      height: 14px;
      background: url("../../../static/img/user_center/default_icon.png")no-repeat;
      position: absolute;
      left: 1px;
    }
    p{
      font-size: 12px;
      line-height: 14px;
      color: #d1434a;
      text-align: left;
    }
  }

  .help-tip {
    font-size: 16px;
    color: #b70000;
    margin-bottom: 16px;
  }
}
.btn_box{
  width: 100%;
  height: 60px;
  padding-bottom: 57px;
  .confirm{
    cursor: pointer;
    display: block;
    width: 355px;
    margin: 0 auto;
    height: 100%;
    line-height: 60px;
    color: #fff;
    background: url("../../../static/img/common/btn_bg.png")no-repeat;
  }
}
.other_box{
  display: table;
  padding-bottom:40px;
  text-align: center;
  width: 100%;
  font-size: 14px;
  color: #1f2d3d;
  letter-spacing: 1px;
  span{
    cursor: pointer;
    &:hover{
      color: #d1434a;
    }
  }
  p{
    padding: 0 43px;
    margin-top: 20px;
    span{
      color: #d1434a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/VerificationCodeLoginForm.vue